var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{ref:"elPopover",attrs:{"placement":"bottom-start","width":_vm.minWidth,"visible-arrow":false,"trigger":"manual","popper-options":_vm.popperOptions,"popper-class":_vm.popperClass_},model:{value:(_vm.value_),callback:function ($$v) {_vm.value_=$$v},expression:"value_"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }